const e = {
  name: "TwitterXLogo",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M14.2,10h-3.4l14.9,20h3.4L14.2,10z"/>
		<path class="st0" d="M40,20c0,11-9,20-20,20C9,40,0,31,0,20S9,0,20,0C31,0,40,9,40,20z M17.2,21.2L7.7,8.4H15l6.3,8.4l7.8-8.4h2.2
			l-9,9.7l10.1,13.5H25l-6.8-9.1l-8.4,9.1H7.6L17.2,21.2z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as TwitterXLogo
};
